/**
 * C3 skeleton: every remaining sword/sabre art in the sample style (render/fx/sampleArt/arts/<art>.ts, built from
 * families/swordArtGen.ts). Breeze is in portArt-breeze.ts, ss-frost stays on portSnow.ts.
 */
import { portArt } from './sampleArt/families/swordKit';
import { BLOODSABRE_FX } from './sampleArt/arts/cinnabar';
import { BROCADE_FX } from './sampleArt/arts/brocade';
import { BRUSH_FX } from './sampleArt/arts/brush';
import { DEMON_FX } from './sampleArt/arts/demon';
import { MOON_FX } from './sampleArt/arts/moon';
import { NINE_FX } from './sampleArt/arts/nine';
import { REDCLIFF_FX } from './sampleArt/arts/redcliff';
import { SAGE_FX } from './sampleArt/arts/sage';
import { SNOW_FX } from './sampleArt/arts/snow';
import { SPRING_FX } from './sampleArt/arts/spring';
import { TAIJI_FX } from './sampleArt/arts/taiji';

for (const l of [SNOW_FX, TAIJI_FX, MOON_FX, NINE_FX, DEMON_FX, SAGE_FX, BRUSH_FX, BROCADE_FX, SPRING_FX, BLOODSABRE_FX, REDCLIFF_FX])
  portArt(l);
